export const breakpoint = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 450,
  tablet: 768,
  tabletL: 950,
  laptop: 1024,
  desktop: 1280,
};

const delta = 0.5;
const size = {
  mobileS: `${breakpoint.mobileS - delta}px`,
  mobileM: `${breakpoint.mobileM - delta}px`,
  mobileL: `${breakpoint.mobileL - delta}px`,
  tablet: `${breakpoint.tablet - delta}px`,
  tabletL: `${breakpoint.tabletL - delta}px`,
  laptop: `${breakpoint.laptop - delta}px`,
  desktop: `${breakpoint.desktop - delta}px`,
};

const device = {
  mobileS: `(max-width: ${size.mobileM})`,
  mobileM: `(max-width: ${size.mobileL})`,
  mobileL: `(max-width: ${size.tablet})`,
  tablet: `(max-width: ${size.tabletL})`,
  tabletL: `(max-width: ${size.laptop})`,
  laptop: `(max-width: ${size.desktop})`,
};

export default device;
